import React, { useEffect, useState } from "react";
import { SignDialog } from "../components/dialog/SignDialog";
import { SignsTable } from "../components/search/SignsTable";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { pDB_user_roles } from "../utils/parameters";
import { useLocation } from "react-router-dom";
import { useDataProvider } from "../api/DataProvider";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import { SubmissionBanner } from "../components/search/SubmissionBanner";
import { useTranslation } from "react-i18next";

export function SignsDB() {
  const { t } = useTranslation("global")

  /* Dialog */
  const [dialogElements, setDialogElements] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [prevDialogPosition, setPrevDialogPosition] = useState(undefined);
  const [snack, setSnack] = useState({ open: false, text: "" });
  const { currentUserRole, genEntryByLemma } = useDataProvider();


  /* Show dialog */
  async function showDialog(row_id) {
    
    /* History */
    //addToHistory(auxSign[pDB.sign_id]).catch(e => console.error(e))
    /* No need of loading */
    const data_dialog_elements = genEntryByLemma(row_id)

    setDialogElements(genEntryByLemma(row_id));
  }

  useEffect(() => {
    if (Object.keys(dialogElements).length > 0) {
      setOpenDialog(true);
    }else{
      setOpenDialog(false);
    }
  }, [dialogElements]);


  const location = useLocation();
  useEffect(() => {
    if (location.lemma !== undefined) {
      setPrevDialogPosition({ lemma: location.lemma, meaning: location.meaning, gloss: location.gloss });
      showDialog([location.lemma])

      if (location.video_sent){
        setSnack({ ...snack, open: true, text: t("sRecordComponent.send_ok"), type: "info" });
      }
      
    }
  }, [location]);

  return (
    <HomeWrapper>
      <SignsTable showDialog={showDialog} favs={false}/>
      <SignDialog dialogElements={dialogElements} setDialogElements={setDialogElements} loading={false} openDialog={openDialog} setOpenDialog={setOpenDialog} prevDialogPosition={prevDialogPosition} setPrevDialogPosition={setPrevDialogPosition}/>
      <HelpSnackbar snack={snack} setSnack={setSnack} />
      <SubmissionBanner origin={'/search'}/>
    </HomeWrapper>
  );
}

// genDataCollab={true}
